import { Link, useParams } from "react-router-dom";
import Header from "../components/header";
import Clickable from "../components/clickable.";
import { useEffect, useState } from "react";
import Page from "../components/page";
import api from "../functions/api";
import Calendar from "react-calendar";
import moment from "moment";
import toast from "../functions/toast";

const EmployeeDetails = () => {
    const [type, setType] = useState(0);
    const [details, setDetails] = useState();
    const [date, setDate] = useState(new Date());
    const [advance, setAdvance] = useState();

    const { id } = useParams();

    const onChange = (newDate) => {
        setDate(newDate);
        getDetails(newDate);
    };

    const getDetails = async (time = new Date()) => {
        try {
            const data = await api.get(
                `/user-details/${id}?date=${time.toString()}`
            );
            setDetails(data);
        } catch (err) {
            console.log("🚀 ~ getDetails ~ err:", err);
        }
    };

    const advanceUser = async () => {
        try {
            await api.post("/add-advance", {
                amount: advance,
                user: id,
            });
            toast.success("Advance added ");
            getDetails();
            setAdvance("");
        } catch (err) {
            console.log("🚀 ~ advanceUser ~ err:", err);
        }
    };

    const getTabClass = (tabName) =>
        type === tabName ? "style-9" : "style-13";

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        const days = document.querySelectorAll(
            ".react-calendar__month-view__days__day"
        );
        for (const item of days) {
            item.classList.remove("green", "red");
        }

        let isFirst = false;

        for (const item of days) {
            const dt = details?.calendar?.find((i) => i.date == item.innerText);
            if (item.innerText == 1) isFirst = true;

            if (dt && isFirst) {
                item.classList.add(
                    dt.machines == 1
                        ? "yellow"
                        : dt.machines == 2
                        ? "green"
                        : "red"
                );
            }
            if (
                isFirst &&
                item.innerText ==
                    details?.calendar[details?.calendar?.length - 1]?.date
            )
                break;
        }
    }, [details, date, type]);

    return (
        <Page title="User Details" className="user-details">
            <div className="style-2">
                <div className="style-5">
                    <div className="style-6">ID :</div>
                    <div className="style-8">{details?.user?._id}</div>
                </div>

                <div className="style-5">
                    <div className="style-6">Name :</div>
                    <div className="style-8">{details?.user?.name}</div>
                </div>

                <div className="style-5">
                    <div className="style-6">Single Machine Salary :</div>
                    <div className="style-8">
                        {details?.user?.singleMachineSalary}
                    </div>
                </div>

                <div className="style-5">
                    <div className="style-6">Duble Machine Salary :</div>
                    <div className="style-8">
                        {details?.user?.dubleMachineSalary}
                    </div>
                </div>
                <br />
                <div className="style-5">
                    <div className="style-6">Advance :</div>
                    <input
                        inputMode="numeric"
                        onChange={(e) => setAdvance(e.currentTarget.value)}
                        value={advance}
                    />
                    <Clickable
                        className="btn"
                        disabled={!advance}
                        onClick={advanceUser}
                    >
                        Save
                    </Clickable>
                </div>
            </div>

            <br />

            <div className="style-12">
                <Clickable
                    className={getTabClass(2)}
                    onClick={() => {
                        setType(2);
                    }}
                    style={{ whiteSpace: "nowrap" }}
                >
                    Salary
                </Clickable>

                <Clickable
                    className={getTabClass(0)}
                    onClick={() => {
                        setType(0);
                    }}
                    style={{ whiteSpace: "nowrap" }}
                >
                    Attendance
                </Clickable>

                <Clickable
                    className={getTabClass(1)}
                    onClick={() => {
                        setType(1);
                    }}
                    style={{ whiteSpace: "nowrap" }}
                >
                    Advance
                </Clickable>
            </div>

            <div className="style-32">
                {type == 0 && (
                    <>
                        <div className="celender">
                            <Calendar onChange={onChange} value={date} />
                        </div>

                        {details?.attendance?.map((item, index) => (
                            <div className="style-53" key={index}>
                                <Link
                                    to={`/attendance-details/${btoa(
                                        JSON.stringify(item)
                                    )}`}
                                    className="style-54"
                                >
                                    <div className="style-55">
                                        <div className="style-56">
                                            {moment(item?.createdAt).format(
                                                "DD/MM/YYYY "
                                            )}
                                        </div>
                                        <div className="style-59">
                                            {item?.shift == 0 ? "DAY" : "NIGHT"}
                                        </div>
                                    </div>

                                    <div className="style-62">
                                        {item?.production}
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </>
                )}

                {type == 2 && (
                    <>
                        {details?.salary?.map((item, index) => (
                            <div className="style-53" key={index}>
                                <Link className="style-54">
                                    {/* <div className="style-55"> */}
                                    <div className="style-57">
                                        <div className="style-56">
                                            {item?.monthYear}
                                        </div>
                                        <div className="style-62">
                                            ₹ {item?.salary}
                                        </div>
                                    </div>

                                    {item?.advance && (
                                        <div className="advance">
                                            <div className="style-56">
                                                Advance :
                                            </div>
                                            <div className="advance-amount">
                                                ₹ {item?.advance}
                                            </div>
                                        </div>
                                    )}
                                    {/* </div> */}
                                </Link>
                            </div>
                        ))}
                    </>
                )}

                {type == 1 && (
                    <>
                        {details?.advance?.map((item, index) => (
                            <div className="style-53" key={index}>
                                <Link className="style-54">
                                    <div className="style-55">
                                        <div className="style-56">
                                            {moment(item?.createdAt).format(
                                                "DD/MM/YYYY hh:mm a"
                                            )}
                                        </div>
                                        <div className="style-62">
                                            ₹ {item?.amount}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </Page>
    );
};

export default EmployeeDetails;
